<h1 mat-dialog-title>Receiving export produts avaliable to shipping</h1>
<div mat-dialog-content>
    <div [formGroup]="formExport">
    <mat-form-field appearance="fill">
        <mat-label>Status description</mat-label>
        <mat-select formControlName="estatus">
          <mat-option
            *ngFor="let opt of PlaceOrderStatusDescripcion"
            [value]="opt.key"
          >
            {{ opt.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    <mat-form-field appearance="fill">
        <mat-label>Routing</mat-label>
        <mat-select formControlName="route">
          <mat-option [value]="item.key" *ngFor="let item of arrayDescripionRouting">{{item.value}}</mat-option>
         
        </mat-select>
      </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>PO#</mat-label>
    <input matInput formControlName="po">
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Reference#</mat-label>
    <input matInput formControlName="references">
  </mat-form-field>
</div>
<h1>  <b>{{labelResponse}}</b></h1>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-button (click)="OnExportreceivingtoshipping()" >Create export</button>
</div>
